export default {
    "Viewers graph": "Graphique des spectateurs",
    "Number of viewers per period of time": "Nombre de spectateurs par période de temps",
    "hour" : "heure",
    "4 hours" : "4 heures",
    "day" : "jour",
    "week" : "semaine",
    "custom" : "personnalisé",
    "csv" : "CSV",
    "from" : "De",
    "to" : "À",
    "resolution" : "Résolution",
    "'To' must be greater than 'From'": "La date de début doit précéder la date de fin"
}